import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.ExcludeFromHeyLoyalty.title',
    defaultMessage: 'Exclude from HeyLoyalty',
  },
  included: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.ExcludeFromHeyLoyalty.included',
    defaultMessage: 'Order included to HeyLoyalty',
  },
  excluded: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.ExcludeFromHeyLoyalty.excluded',
    defaultMessage: 'Order excluded from HeyLoyalty',
  }
})
